import classNames from "classnames";

export const Loading = ({
  size = "md",
  color = "primary",
  className = "",
  ...props
}) => {
  const sizeClasses = {
    xs: "w-4 h-4",
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  const colorClasses = {
    primary: "text-primary-600 dark:text-primary-400",
    white: "text-white",
    gray: "text-gray-600 dark:text-gray-400",
  };

  const classes = classNames(
    "animate-spin",
    sizeClasses[size],
    colorClasses[color],
    className
  );

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
};

export const LoadingSpinner = ({ className = "", ...props }) => {
  return (
    <div className={classNames("flex items-center justify-center py-8", className)} {...props}>
      <Loading size="md" color="primary" />
    </div>
  );
};

